import React from 'react';
import { DialogComponent } from '../../../../../../../../Components';
import { getPublicDownloadableLink } from '../../../../../../../../Helper';
import PDFViewer from '../../../../../../../../Components/PDFViewer/PDFViewer';

function PreviewProposalDialog({
  isOpen,
  onClose,
  activeitem,
  translationPath,
}) {
  return (
    <>
      <DialogComponent
        isOpen={isOpen}
        onCloseClicked={onClose}
        titleText={'Preview'}
        dialogContent={
          <>
            <PDFViewer
              fileUrl={getPublicDownloadableLink(activeitem?.fileId)}
            />
          </>
        }
        parentTranslationPath={translationPath}
      />
    </>
  );
}

export default PreviewProposalDialog;
